import ListingsListPageContainer from './containers/ListingsListPageContainer'

export default ListingsListPageContainer
